export default {
  data() {
    return {
      selectData: {}, // 表格选中行编辑数据
      dialogType: 2, // 1创建 2编辑 3查看
    }
  },
  methods: {
    // 提交数据
    formSubmit(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      const mapList = this.formItems.map(e => e.key)
      const rData = {}

      mapList.forEach(x => {
        if (this.selectData[x] !== result[x]) {
          rData[x] = result[x]
        }
      })
      rData.id = this.selectData.id // 绑定修改的数据id
      console.log(rData)

      this.$api.util_modify(this.sign, rData).then(res => {
        if (res.data.status == 0) {
          this.$message.success('修改成功！')
        } else { this._status(res.data) }
      })
    },
    // 获取数据
    getDataCb(rD = {}) {
      return this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          const _R = JSON.parse(res.data.data)
          if (_R.length) {
            console.log(`%c_R:`, 'color: #f00;', _R[0])
            return _R[0]
          } else {
            return {}
          }
        } else { this._status(res.data) }
      })
    },
  },
  async created() {
    this.selectData = await this.getDataCb()
    this.$refs.FormBox.open(this.dialogType, this.selectData)
  },
}